import { useState, useEffect } from "react";
import styles from "../../../assets/stylesheets/sass/Filter.module.scss";
import eye from "../../../assets/icons/eye.svg";
import eye_off from "../../../assets/icons/eye_off.svg";

const Option = ({label, value, options, returnedOptions}) => {

    const handleChange = () => {
        let tmp_options = {...options};
        if(tmp_options[label]){
            delete tmp_options[label]
        }
        else {
            tmp_options[label] = value;
        }
        returnedOptions(tmp_options)
    }

    return (
        <button className={styles.mc_button} onClick={()=>{handleChange()}}><img src={options[label] ? eye : eye_off} alt="eye"/>{label}</button>
    )
}

export default function MultipleChoice({system, data, returnedArray, placeholder_hide="Verberg alles", placeholder_show="Toon alles"}){
    useEffect(()=>{
        setOptions(system.options);
    }, [])

    const [options, setOptions] = useState([]);

    const filterData = (value) => {
        
        setOptions(value)

        let values = []
        Object.keys(value).forEach(option => {
            values = values.concat(value[option])
        });

        if(values.length < 2){
            setStateToggle(false);
        }
        else{
            setStateToggle(true);
        }

        let tmp_data = [];
        for (let i = 0; i < data.length; i++) {
            if(values.includes(data[i][system.selector].toString())){
                tmp_data = tmp_data.concat(data[i])
            }       
        }

        returnedArray(tmp_data);
    }

    const [stateToggle, setStateToggle] = useState(true)

    const toggleOptions = (state) => {
        if(!state){
            setStateToggle(true)
            filterData(system.options);
        }
        else {
            setStateToggle(false);
            filterData({});
        }
    }

    return (
        <>
        <button className={styles.backbutton} onClick={()=>toggleOptions(stateToggle)}>{stateToggle === true ? placeholder_hide : placeholder_show}</button>
        <div className={styles.mc_options}>
        {(Object.keys(system.options).map((v, i)=>{
            return (
                <Option key={i} label={v} value={system.options[v]} options={options} returnedOptions={(value)=>filterData(value)}/>
            )
        }))}
        </div>
        </>
    )
}